export default {"src":"/_next/static/media/guided_tours.7582c0dc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};